import ManualConfigManagement from './views/ManualConfigManagement.vue';
import ManualConfig from './ManualConfig.vue';
import { productBoostRoutes } from './views/productBoost/routes';
import { saleRateIndexingRuleRoutes } from './views/saleRateIndexingRule/routes';
import { groupIndexingRuleRoutes } from './views/groupIndexingRule/routes';
import { productIndexingRoutes } from './views/productIndexing/routes';
import { productRecommendationRoutes } from './views/productRecommendation/routes';
import { menuInitialRecommendationRoutes } from './views/menuInitialRecommendation/routes';
import { menuBannerRecommendationRoutes } from './views/menuBannerRecommendation/routes';
import { linkTreeRoutes } from './views/linkTree/routes';
import { tableQrRoutes } from './views/tableQr/routes';

export const manualConfigRoutes = [
  {
    path: 'manualConfig',
    component: ManualConfig,
    children: [
      ...productBoostRoutes,
      ...saleRateIndexingRuleRoutes,
      ...groupIndexingRuleRoutes,
      ...productIndexingRoutes,
      ...productRecommendationRoutes,
      ...menuInitialRecommendationRoutes,
      ...menuBannerRecommendationRoutes,
      ...linkTreeRoutes,
      ...tableQrRoutes,
      { path: '', component: ManualConfigManagement, name: 'manualConfig' }
    ]
  }
];
